import React, { useEffect, useState } from 'react';
import { AdConfig } from '../types/extension';

interface ExtensionSlotProps {
    config: AdConfig;
    className?: string;
}

const ExtensionSlot: React.FC<ExtensionSlotProps> = ({ config, className }) => {
    const [htmlContent, setHtmlContent] = useState<string>('');

    useEffect(() => {
        if (config.path) {
            // Ensure path is absolute relative to domain root to avoid issues with sub-routes
            const path = config.path.startsWith('.') ? config.path.substring(1) : config.path;
            const normalizedPath = path.startsWith('/') ? path : `/${path}`;

            fetch(normalizedPath)
                .then(res => res.text())
                .then(text => setHtmlContent(text))
                .catch(err => console.error(`Failed to load ad content from ${normalizedPath}`, err));
        } else if (config.code) {
            setHtmlContent(config.code);
        }
    }, [config]);

    // Determine label
    const label = `[PR] ${config.name || 'Ad'}`;

    return (
        <div className={`relative border rounded-lg overflow-hidden group aspect-square border-gray-200 dark:border-gray-700 bg-white flex flex-col items-center justify-center ${className}`}>
            {!htmlContent ? (
                <div className="animate-pulse bg-gray-200 w-full h-full" />
            ) : (
                <>
                    <div className="absolute top-0 left-0 z-10">
                        <div className="bg-cyan-600 text-white text-xs px-4 py-0.5 transform -skew-x-[15deg] -ml-2">
                            <span className="block transform skew-x-[15deg] pl-2">
                                {label.split('/').map((part, index) => (
                                    <React.Fragment key={index}>
                                        {index > 0 && <br />}
                                        {part}
                                    </React.Fragment>
                                ))}
                            </span>
                        </div>
                    </div>
                    <iframe
                        srcDoc={`
                    <html>
                    <head>
                        <style>body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; overflow: hidden; }</style>
                    </head>
                    <body>
                        ${htmlContent}
                    </body>
                    </html>
                `}
                        title={config.name || "Ad"}
                        width={config.width || "100%"}
                        height={config.height || "100%"}
                        frameBorder="0"
                        scrolling="no"
                        style={{ pointerEvents: 'auto' }}
                    />
                </>
            )}
        </div>
    );
};

export default ExtensionSlot;
